module.exports = __webpack_public_path__ + "assets/img/Emotion_Sticker.32cc2b08.svg";